const wpcf7Form = document.querySelector('.wpcf7');
const submitButton = document.getElementById('submit-button');

if (wpcf7Form) {
    wpcf7Form.addEventListener('wpcf7submit', updateFormLabels);
}

if (submitButton) {
    submitButton.addEventListener('click', () => {
        const inputs = document.querySelectorAll('[class^=wpcf7-form-control]');
        inputs.forEach((element) => element.parentElement.parentElement.classList.remove('error'));
    });
}

function updateFormLabels() {
    const inputs = document.querySelectorAll('[class^=wpcf7-form-control]');
    inputs.forEach((element) => {
        const label = element.parentElement.parentElement;
        if (element.classList.contains('wpcf7-not-valid')) {
            label.classList.add('error');
        } else {
            label.classList.remove('error');
        }
    })
}
